import React from 'react'

import img1 from '../../Images/1 (1).webp'
import img2 from '../../Images/1 (2).webp'
import img3 from '../../Images/1 (1).webp'
import { Link } from 'react-router-dom'
import Collegeranking from '../../Collegranking/Collegeranking'



const Ranking = () => {
    return (
        <div className="bg-gray-50 min-h-screen pb-20">
            {/* Banner */}
            <div className="bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 text-white py-20 text-center shadow-lg relative overflow-hidden">
                <div className="absolute inset-0 bg-white opacity-5 pattern-grid-lg"></div>
                <div className="container mx-auto px-4 relative z-10">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">India’s Best Colleges 2025</h1>
                    <p className="text-blue-100 max-w-3xl mx-auto text-lg leading-relaxed">
                        Explore the Top Colleges in India for 2025! Whether you're looking for the best engineering, medical, management, or law colleges, our updated rankings help you make an informed choice.
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-4 mt-8">
                {/* Breadcrumb & Title */}
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
                    <Link to="/" className="hover:text-brand-orange transition"><i className='fa fa-home text-lg'></i></Link>
                    <span>/</span>
                    <span className="font-semibold text-gray-700">India Colleges</span>
                </div>

                <div className="mb-8 pl-4 border-l-4 border-brand-orange">
                    <h3 className="text-2xl font-bold text-gray-800">
                        List of Top Colleges in India Based on 2025 Ranking
                    </h3>
                </div>

                {/* Featured Images / Highlights */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                    {[img1, img2, img3].map((img, index) => (
                        <div key={index} className="rounded-2xl overflow-hidden shadow-md border border-gray-200 hover:shadow-xl transition-all duration-300 group">
                            <div className="h-48 overflow-hidden">
                                <img src={img} alt="Ranking Highlight" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Main Ranking List Content */}
            <Collegeranking />
        </div>
    )
}

export default Ranking
